import { computed, Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ReportParameterStore {
  private _isValid = signal(true);
  private _customParams = signal<Record<string, any>>({});
  private _generalParams = signal<Record<string, any>>({});

  readonly isValid = this._isValid.asReadonly();
  readonly customParams = this._customParams.asReadonly();
  readonly generalParams = this._generalParams.asReadonly();
  readonly allParams = computed(() => ({ ...this._generalParams(), ...this._customParams() }));

  setValidity(value: boolean) {
    this._isValid.set(value);
  }

  setCustomParams(params: Record<string, any>) {
    this._customParams.set(params);
  }

  setGeneralParams(params: Record<string, any>) {
    this._generalParams.set(params);
  }


  clearAll() {
    this._customParams.set({});
    this._generalParams.set({});
    this._isValid.set(true);
  }
}